import { ChangeDetectorRef, Component, inject, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NoDataFoundComponent } from "../../../commons/no-data-found/no-data-found.component";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { DateService } from '../../../shared/date.service';
import { MatDialog } from '@angular/material/dialog';
import { BuzonEditComponent } from './buzon-edit/buzon-edit.component';
import { MatButtonModule } from '@angular/material/button';
import { BuzonService } from '../../../services/buzon.service';
import { Buzon } from '../../../models/Buzon';
import { AuthService } from '../../../services/auth.service';
import { ScnackbarData, SnackbarStyles, ToastService } from '../../../commons/toast.service';
import { DlgDeleteComponent } from '../../../commons/dlg-delete/dlg-delete.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-buzon',
  imports: [MatToolbarModule, MatIconModule, MatTabsModule,
    MatTableModule, NoDataFoundComponent,
    MatToolbarModule, MatIconModule, MatButtonModule,
    MatProgressBarModule, MatPaginatorModule, MatSortModule,
    MatFormFieldModule, MatInputModule
  ],
  templateUrl: './buzon.component.html',
  styleUrl: './buzon.component.scss',
})
export class BuzonComponent implements OnInit {
  
  isLoadingResults = false;
  resultsLength = 0;
  dataSource = new MatTableDataSource<Buzon>([]);
  searchValue: string = '';
  private searchSubject: Subject<string> = new Subject<string>();
  private subscriptions: Subscription = new Subscription();
  buzonService = inject(BuzonService);
  dialog = inject(MatDialog);
  displayedColumns = ['departamento', 'cargo', 'op'];
  private tokenData = this.authService.getTokenData();
  isAdmin = this.tokenData ? this.tokenData.roles.includes('sgd_admin') : false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private authService: AuthService,
    private cdr: ChangeDetectorRef, 
    private dateService: DateService,
    private dlg: MatDialog,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.loadData();
    this.subscriptions.add(
      this.searchSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe(value => {
        this.searchValue = value;
        this.loadData(value);
      })
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadData(criterio: string = '') {
    this.isLoadingResults = true;    
    this.buzonService.selectAll(criterio).subscribe((data: any) => {
      this.dataSource = new MatTableDataSource<Buzon>(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.resultsLength = data.length;
      this.isLoadingResults = false;
      this.cdr.detectChanges();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value || '';
    this.searchSubject.next(filterValue);
  }

  clearSearch() {
    this.searchValue = '';
    this.searchSubject.next('');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date!)
  }

  onAdd(){
    let dialogRef = this.dialog.open(BuzonEditComponent, {
      height: '700px',
      width: '600px',
    }).afterClosed().subscribe(result => {
      if(result){
        this.loadData();
      }
    });
  }

  onEdit(row: Buzon) {
    let dialogRef = this.dialog.open(BuzonEditComponent, {
      height: '700px',
      width: '600px',
      data: row
    }).afterClosed().subscribe(result => {
      if(result){
        this.loadData();
      }
    });;
  }

  onDelete(row: Buzon) {
    const dialogRef = this.dlg.open(DlgDeleteComponent, {
      maxWidth: "40vw",
      width: "400px"
    });
    dialogRef.afterClosed().subscribe((result: number | undefined) => {
      if (result === 1) {
        this.buzonService.deleteBuzon(row.id).subscribe({
          next: (_) => {
            this.loadData();
            const snackbarData: ScnackbarData = {
              message: "Registro eliminado",
              style: SnackbarStyles.Success,
              iconName: "check_circle"
            }
            this.toast.show(snackbarData)
          },
          error: (err: HttpErrorResponse) => {            
            const snackbarData: ScnackbarData = {
              message: err.error || "Error al eliminar el registro",
              style: SnackbarStyles.Error,
              iconName: "error"
            }
            this.toast.show(snackbarData)
          }
        })
      }
    });
  }

}
